<template>
    <div class="privacy">
        プライバシーポリシー
    </div>
</template>

<script>
export default {
    mounted(){
        const title = "プライバシーポリシー｜エモーションダイアリー"
        const description = "プライバシーポリシーのページ"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    } 

}
</script>

<style>

</style>